import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../../../../app.settings';


@Injectable({
  providedIn: 'root'
})
export class SurveyfeedbackService {

    SurveyFeedUrl = `${AppSettings.API_ENDPOINT}/${'get-survey-feedback'}`;

  constructor(private http: HttpClient) { }

  getSurveyFeedback(){
     return this.http.get(this.SurveyFeedUrl);
  }
}
